
const Diamond = (props) => {
    let p_className1 = "backgroundDiamond";
    let p_className2 = "otherBackgroundDiamond";
    return (<div className={props.className}><div className={p_className1}></div>
    <div className={p_className2}></div></div>)
}

export default Diamond;
